import isBrowser from 'utils/isBrowser';
import { logError } from 'utils/logger';

export const setCookie = (name, value, days = 2) => {
	try {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${date.toUTCString()}; secure; samesite=strict`;
	} catch (error) {
		logError('Error setting cookie', error);
	}
};

export const getCookie = (name) => {
	try {
		if (isBrowser()) {
			const value = `; ${document.cookie}`;
			const parts = value.split(`; ${name}=`);
			if (parts.length === 2)
				return decodeURIComponent(parts.pop().split(';').shift());
		}
	} catch (error) {
		logError('Error getting cookie', error);
	}
	return null;
};
